import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { matchPath } from 'react-router';
import { Button, Card, CardBody, Col, Container, Form, InputGroup, InputGroupAddon, InputGroupText, Row } from 'reactstrap';
import { bindActionCreators } from 'redux';

import * as authActions from '../../actions/authActions';
import Messages from '../../components/common/Toastr/messages';
import { nextField } from '../../util/nextField';
import { InputPassword } from '../common/InputPassword';
import { getIPs } from '../../util/helper';

class Page extends Component {
    constructor(props) {
        super(props);
        this.state = {
            voltar: false,
            Private_IP: '0.0.0.0',
            Public_IP: '0.0.0.0',
            logout: false,
            sucesso: false,
            passwordold: '',
            password1: '',
            password2: '',
            options: this.props.options || {},
        }
        this.voltar = this.voltar.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleEnter = this.handleEnter.bind(this);
        this.alterpwd = this.alterpwd.bind(this);
        this.logout = this.logout.bind(this);
    }

    componentWillMount() {

        getIPs((ip) => {
            if (ip.match(/^(192\.168\.|169\.254\.|10\.|172\.(1[6-9]|2\d|3[01]))/)) {
                this.saveState('Private_IP', ip)
            } else {
                this.saveState('Public_IP', ip)
            }
        })
    }

    saveState(key, value) {
        this.setState({ [key]: value })
    }

    componentWillUnmount() {
        if(this.props.location){
            const match_login = matchPath(this.props.location.search, {
                path: '?voltar=true&login',
                exact: false,
                strict: false
            })
            if (!match_login)
                this.setState({ voltar: false, sucesso: false, passwordold: this.props.user.provisionalpassword, password1: '', password2: '' });
        }
        this.props.actions.reset();
    }

    async voltar() {
        if (this.props.user.provisionalLogin || new Date() > new Date(this.props.user.nextchangepwd))
            sessionStorage.removeItem('_nscorporate_user')

        return document.location.href = !!this.props.options && !!this.props.options.redirectBack ? this.props.options.redirectBack : '/'
    }

    async logout() {
        await this.props.actions.logout();
    }

    handleChange(evt) {
        this.setState({ [evt.target.name]: evt.target.value });
    }

    handleEnter(event) {
        nextField(event);
    }

    async alterpwd() {

        let passwordOld = this.state.passwordold;
        if (this.props.user.provisionalLogin && this.props.user.provisionalpassword) {
            passwordOld = this.props.user.provisionalpassword;
        }


        if (passwordOld.length > 4) {
            await this.props.actions.validaUser({ login: this.props.user.login, password: passwordOld })
            if (this.props.validated) {
                if (this.state.password1.length > 4 && this.state.password2.length > 4) {
                    if (this.state.password1 === this.state.password2) {
                        var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,20})");
                        if (strongRegex.test(this.state.password1)) {
                            const ip = { 'Private_IP': this.state.Private_IP,
                            'Public_IP': this.state.Public_IP }
                            await this.props.actions.alterpwd(this.props.user.login, passwordOld, this.state.password1, this.state.password2, ip)
                        } else {
                            toastr.error('Atenção', 'Senha precisa ter: uma letra maiúscula, uma letra minúscula, um número, um caractere especial (@#$ %) e conter entre 8-20 caracteres.');
                        }
                    } else {
                        toastr.error('Atenção', 'Senhas não conferem!');
                    }
                } else {
                    toastr.error('Atenção', 'Senhas inválidas!');
                }
            } else {
                toastr.error('Atenção', 'Senhas atual inválida!!');
            }
        } else {
            toastr.error('Atenção', 'Senhas atual inválida!');
        }
    }

    render() {
        const { options: { bgColorContainer, boxTitle, bgColorBoxTitle, textColorBoxTitle } } = this.state;

        if (!this.props.user || this.state.logout) {
            return document.location.href = this.props.options.redirectBack || '/'
        }

        if (this.state.voltar || this.props.sucesso) {
            return document.location.href = '/'
        }
        return (
            <div className="app flex-row align-items-center">
                <Container>
                    <Form id="formAlterPwd" className="mp-0 w-100">
                        <Row className="justify-content-center">
                            <Col md="6">
                                <Card className="mx-4" style={{
                                    backgroundColor: bgColorContainer || '',
                                }}>
                                    {boxTitle && <Card md="8" style={{
                                        backgroundColor: bgColorBoxTitle,
                                        borderRadius: '0.25rem 0.25rem 0 0',
                                        borderStyle: 'none',
                                        margin: '0',
                                        padding: '12px 0 0 24px',
                                }}>
                                    <h1 style={{color: textColorBoxTitle, fontSize: '25px'}}>{boxTitle}</h1>
                                </Card>}
                                    <CardBody className="p-4">
                                        <h1>Alterar Senha</h1>
                                        <InputGroup className="mb-3" style={{ display: (this.props.user.provisionalLogin ? 'none' : 'flex') }} >
                                            <InputGroupAddon addonType="prepend">
                                                <InputGroupText>
                                                    <i className="icon-lock"></i>
                                                </InputGroupText>
                                            </InputGroupAddon>
                                            <InputPassword
                                                name="passwordold"
                                                id="passwordold"
                                                placeholder="Senha atual"
                                                autoFocus={true}
                                                onChange={this.handleChange}
                                                onKeyDown={this.handleEnter}
                                            />
                                        </InputGroup>
                                        <InputGroup className="mb-3">
                                            <InputGroupAddon addonType="prepend">
                                                <InputGroupText>
                                                    <i className="icon-lock"></i>
                                                </InputGroupText>
                                            </InputGroupAddon>
                                            <InputPassword
                                                name="password1"
                                                id="password1"
                                                placeholder="Senha"
                                                onChange={this.handleChange}
                                                onKeyDown={this.handleEnter}
                                            />
                                        </InputGroup>
                                        <InputGroup className="mb-4">
                                            <InputGroupAddon addonType="prepend">
                                                <InputGroupText>
                                                    <i className="icon-lock"></i>
                                                </InputGroupText>
                                            </InputGroupAddon>
                                            <InputPassword
                                                name="password2"
                                                id="password2"
                                                placeholder="Confirmar senha"
                                                onChange={this.handleChange}
                                                onKeyDown={this.handleEnter}
                                            />
                                        </InputGroup>
                                        <Button className="text-white" color="primary-smart" block onClick={() => { this.alterpwd() }}>Enviar</Button>
                                        <Button color="secundary-smart" block onClick={() => { this.voltar() }} >Voltar</Button>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        <Messages />
                    </Form>
                </Container>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    user: state.authreducer.user,
    sucesso: state.authreducer.sucesso,
    validated: state.authreducer.validated,
    alterpwd: state.authreducer.alterpwd,
    provisionalLogin: state.authreducer.provisionalLogin
})

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(authActions, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(Page)
